import React from "react";
import Dashboardmenus from "./Dashboardmenus";
import { Link } from "react-router-dom";
import { getBaseUrl } from "../../common/BaseUrl";

const Accountrestore = () => {
   let base_url = getBaseUrl();
  return (
    <React.Fragment>
      <Dashboardmenus />
      <div className="dashboard-contentbody">
        <section className="DepositSec">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="cardBox mb-4">
                  <h4 className="card_title">Restore account</h4>
                  <div className="alertBox">
                    <div className="alert alert-success">
                      <span className="text-white">
                        Your account has been Successfully restored. Welcome
                        back on board!
                      </span>
                    </div>
                  </div>
                    <Link to={base_url} type="button" className="btn bg_btn">
                                      Go to Home
                                    </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default Accountrestore;
